// DEPENDENCIES
import React from 'react';
// COMPONENTS
import { Link } from 'react-router-dom';
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';

const ActionStrip = (props) => {
  return (
    <Link
      className={`action-strip ${props.containerClassName ? props.containerClassName : ''} ${
        props.backgroundColor ? props.backgroundColor : 'light--bg'
      } ${props.highlighted ? 'highlighted' : ''}`}
      to={props.rightActionTo || props.to || '#'}
      onClick={props.primaryOnClick}
    >
      <CustomBlock className='action-strip-title-container'>
        <p className='action-strip-title'>{props.title}</p>
      </CustomBlock>

      <CustomBlock className='right-action-container'>
        {props.rightActionText && (
          <p className={`right-action-text${props.badgeColor ? '--badge' + ' ' + props.badgeColor : ''}`}>{props.rightActionText}</p>
        )}

        {props.rightActionIcon}
      </CustomBlock>
    </Link>
  );
};

export default ActionStrip;
